var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { OGPanel } from '@opengear/panel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useFormSync } from '@/hooks/use-form-sync';
import { AreaField, SmfStatusField } from './smf-form-controls';
import { FormActions, FormContainer, ResetButton, SubmitButton } from '@/components/layout/forms';
import { transformSmfApiDataToForm, transformSmfFormDataToApi } from './transformers';
import { useSystemSmf } from '@/api/system/smf';
export function SmfForm(_a) {
    var _this = this;
    var data = _a.data, permissions = _a.permissions, submitHandler = _a.submitHandler;
    var t = useTranslation().t;
    var isFetching = useSystemSmf().isFetching;
    var sourceValues = useMemo(function () { return transformSmfApiDataToForm(data.system_smf); }, [data]);
    // Form state
    var methods = useForm({ mode: 'onTouched', defaultValues: sourceValues });
    // Alert the user of data changes
    useFormSync(methods.formState.defaultValues, sourceValues, methods.reset, t('pages.smf.form.reset_warning.header'), isFetching);
    // Submit handler
    var onSubmit = useCallback(function (formData) { return __awaiter(_this, void 0, void 0, function () {
        var updatedSmfSettings;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, submitHandler(transformSmfFormDataToApi(formData))
                    // If successful, reset
                ];
                case 1:
                    updatedSmfSettings = _a.sent();
                    // If successful, reset
                    if (updatedSmfSettings) {
                        methods.reset(transformSmfApiDataToForm(updatedSmfSettings.system_smf));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [methods, submitHandler]);
    return (_jsx(OGPanel, __assign({ sx: { padding: 0 } }, { children: _jsxs(FormContainer, __assign({ mode: "update", methods: methods, permissions: permissions, onSubmit: onSubmit }, { children: [_jsxs(Stack, __assign({ padding: 2 }, { children: [_jsxs(Stack, __assign({ direction: "row", spacing: 1, marginBottom: 2 }, { children: [_jsx(ReportProblemIcon, { style: { fontSize: '20px' } }), _jsx(Typography, __assign({ gutterBottom: true }, { children: t('pages.smf.warning_sub_message') }))] })), _jsx(SmfStatusField, {}), _jsx(AreaField, {})] })), _jsx(Stack, __assign({ padding: 2 }, { children: _jsxs(FormActions, { children: [_jsx(ResetButton, {}), _jsx(SubmitButton, {})] }) }))] })) })));
}
